import { getPublicRuntimeConfig } from "../config";
import logger from "./logger";
import { getMaintainXUrl } from "./maintainxUrl";
import { getExistingUtmParameters, getUtmParameters } from "./utmParameters";

type Callback = (e: Error | null, data: object | string) => any;

declare global {
  interface Window {
    // https://docs.branch.io/web/integrate
    // More functions available see link.
    branch?: {
      init(key: string, cb?: Callback): void;
      link(linkData: object, cb?: Callback): void;
      sendSMS(phone: string, linkData: object, options?: object, cb?: Callback): void;
    };
  }
}

export function isBranchLoaded() {
  return typeof window.branch === "object";
}

export function getBranchLinkForProcedure(procedureUid: string, from: string) {
  const fallback = `${getPublicRuntimeConfig().branchFallbackUrl}${getUtmParameters({
    procedureUid,
  })}`;
  const desktopUrl = `${getMaintainXUrl()}${getUtmParameters({ procedureUid })}`;

  return new Promise<string>((resolve) => {
    if (!window.branch) {
      resolve(fallback);
      return;
    }

    const existingUtmParameters = getExistingUtmParameters();

    window.branch.link(
      {
        channel: existingUtmParameters["~channel"] ?? "GPL",
        feature: existingUtmParameters["~feature"] ?? from,
        campaign: existingUtmParameters["~campaign"],
        data: {
          gpl_procedure_uid: procedureUid,
          type: "GPL_IMPORT_PROCEDURE",
          $desktop_url: desktopUrl,
        },
      },
      function (err, link) {
        if (typeof link === "string") {
          resolve(link);
        } else if (err) {
          logger.error(err, { from: "branch.link" });
          resolve(fallback);
        }
      },
    );
  });
}
